import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Inicio'
import Registro from '@/components/Registro/Registro'
import Busqueda from '@/components/Busqueda/Busqueda'
import Capacitacion from '@/components/Capacitacion/Capacitacion'
import Juramento from '@/components/Juramento/Juramento'
import Denuncia from '@/components/Denuncia'
import Credencial from '@/components/Credenciales/Credencial'
import Normativa from '@/components/Normativa/Normativa'
import Certificacion from '@/components/Certificacion/Certificacion'
import Ruanna from '@/components/Ruanna/Ruanna'
import Ciudadania from '@/components/Ciudadania'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'Principal',
      redirect: 'Inicio'
    },
    {
      path: '/inicio',
      name: 'Inicio',
      component: Home
    },
    {
      path: '/registro',
      name: 'Registro',
      component: Registro
    },
    {
      path: '/busqueda',
      name: 'Busqueda',
      component: Busqueda
    },
    {
      path: '/capacitacion',
      name: 'Capacitacion',
      component: Capacitacion
    },
    {
      path: '/convocatoria-tribunal',
      name: 'Convocatoria',
      component: () => import('@/components/Convocatoria/Tribunal')
    },
    {
      path: '/normativa',
      name: 'Normativa',
      component: Normativa
    },
    {
      path: '/certificacion',
      name: 'Certificacion',
      component: Certificacion
    },
    {
      path: '/credenciales',
      name: 'Credencial',
      component: Credencial
    },
    {
      path: '/credencial-digital',
      name: 'CredencialDigital',
      component: () => import('@/components/CredencialDigital/Verificacion.vue')
    },
    {
      path: '/certificado-funcionamiento',
      name: 'CertificadoFuncionamiento',
      component: () => import('@/components/CertificadoFuncionamiento/Verificacion.vue')
    },
    {
      path: '/denuncia',
      name: 'Denuncia',
      component: Denuncia
    },
    {
      path: '/juramento',
      name: 'Juramento',
      component: Juramento
    },
    {
      path: '/ruanna',
      name: 'Ruanna',
      component: Ruanna
    },
    {
      path: '/buzon-digital',
      name: 'BuzonDigital',
      component: Ciudadania
    },
    {
      path: '/solicitud-ciudadania-digital',
      name: 'SolicitudBuzon',
      component: () => import('@/components/Ciudadania/SolicitudValidacion.vue')
    },
    {
      path: '/politica-privacidad',
      name: 'PoliticaPrivacidad',
      component: () => import('@/components/TerminosCondicionesApp.vue'),
      meta: {
        title: 'Términos y Condiciones - MiRPA DIGITAL'
      }
    },
    {
      path: '*',
      name: 'NotFound',
      component: () => import('@/common/layout/pages/AppNotFound.vue')
    }

  ]
})

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  } else {
    document.title = 'RPA - Registro Público de la Abogacía'
  }
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js